import { createTheme } from "@mui/material";

// Violeta del WebAdmin 1 (FlutterFlow). Extraído visualmente del screenshot:
// - Banner login / sidebar: #5B2FEB (approx)
// - Botón primario:         #4F27D8
// - Texto sobre violeta:    white
// - Accent row hover:       #EEE7FF

export const BRAND = {
  primary:        "#5B2FEB",
  primaryDark:    "#4F27D8",
  primaryLight:   "#EEE7FF",
  sidebarBg:      "#5B2FEB",
  sidebarItemBg:  "#FFFFFF",
  pendingBg:      "#E9E4FE",
  pendingText:    "#5B2FEB",
};

export const theme = createTheme({
  palette: {
    primary:   { main: BRAND.primary, dark: BRAND.primaryDark, contrastText: "#fff" },
    secondary: { main: "#6B7280" },
    background:{ default: "#FFFFFF", paper: "#FFFFFF" },
  },
  typography: {
    fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root:  { textTransform: "none", borderRadius: 999, fontWeight: 500 },
        containedPrimary: { paddingInline: 28, paddingBlock: 10 },
      },
    },
    MuiTextField: {
      defaultProps: { variant: "outlined", fullWidth: true },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 999,
            "& fieldset": { borderColor: BRAND.primary, borderWidth: 2 },
          },
        },
      },
    },
  },
});
